import { render } from "./areaSchoolEchart.vue?vue&type=template&id=8c73b882&scoped=true"
import script from "./areaSchoolEchart.vue?vue&type=script&lang=js"
export * from "./areaSchoolEchart.vue?vue&type=script&lang=js"

import "./areaSchoolEchart.vue?vue&type=style&index=0&id=8c73b882&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c73b882"]])

export default __exports__